module.exports = __webpack_public_path__ + "static/amazon_logo-b82a715c9ccedca1c319c356727c74c2.png";